module.exports = __webpack_public_path__ + "img/a-back.63dcc022.png";